export enum AuthState {
  INACTIVE = 0x0,
  ERROR = 0x1,
  CHECKING = 0x2,
  VERIFY = 0x4,
  SETUP = 0x8,
  LOGIN = 0x10,
  LOGOUT = 0x20,
  DEBUG = 0x100
}